import React from "react";
import "./BatchEditorLeftMenu.css";
import BatchEditorObjectPanel from "./panels/BatchEditorObjectPanel";
import BatchEditorLayoutPanel from "./panels/BatchEditorLayoutPanel";

const BatchEditorLeftMenu = ({ isOpen }) => {
  if (!isOpen) return null;
  return (
    <div className="batch-editor-left-menu">
      <div className="menu-section">
        <div className="menu-title">Preview</div>
        <div className="menu-content" style={{ display: "flex", flexDirection: "column", gap: 24 }}>
          <BatchEditorLayoutPanel />
          <BatchEditorObjectPanel />
        </div>
      </div>
    </div>
  );
};

export default BatchEditorLeftMenu;
